import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import $ from 'jquery';

import { selectUrlData } from '../../redux/train/train.selector';

import iconBack from '../../assets/back-arrow.png';
import iconClose from '../../assets/close.png';

class FaqDetailsMeal extends React.Component {
    constructor(props) {
        super(props);
        window.jQuery = $;
        window.$ = $;
        global.jQuery = $;
    }
    myFunction(e) {
        $('.single-faq').removeClass('active');
        $(e).parent('.single-faq').addClass('active');
    }
    render() {
        const { urlData } = this.props;
        return (
            <div>
                <div className="faq-header">
                    <a href={'/ttbhelp?' + urlData}><img src={iconBack} alt="" title="" /></a>
                    <h2>Frequently Asked Questions(FAQ):</h2>
                    <Link to={'/ttbhelp/faq'}><img src={iconClose} alt="" title="" /></Link>
                </div>
                <div className="faq-content">
                    <h4>Meal Preferences and Onboard Services</h4>

                    <h2>What do you need help with?</h2>

                    <div className="faq-accordian">
                        <div className="single-faq active">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I update or change my meal preference?</h3>
                            <p>When booking, make sure to update your meal preferences in the passenger details section.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What are the meal options available on the train?</h3>
                            <p>The meal options available on trains vary based on the service type and train category. Common options include:</p>

                            <li><span>Vegetarian Meals:</span> Standard Indian vegetarian meals, often including rice, chapati, vegetables, and dal.</li>
                            <li><span>Non-Vegetarian Meals:</span> Meals featuring chicken or egg curry, along with rice, chapati, and side dishes.</li>
                            <li><span>Snacks & Light Meals:</span> Sandwiches, samosas, cutlets, and other light snacks are available, especially on shorter journeys.</li>

                            <p>Meal availability and variety depend on the train service, such as Rajdhani, Shatabdi, or Duronto, where meals may be pre-included in the fare.</p>

                            <p>Additionally, you can order food from the RailYatri <em>"Food on Train"</em> section as well.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I order food during my train journey?</h3>
                            <li>From the RailYatri app home screen, go to the <em>"Food on Train"</em> section.</li>
                            <li>You can place an order by using either your Train or PNR information.</li>
                            <li>Once the delivery stations are shown, select your preferred food from the menu.</li>
                            <li>Complete the order by clicking <em>"Proceed"</em>.</li>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>Can I pre-order meals when booking my ticket?</h3>
                            <p>Yes, you can pre-order meals while booking your train ticket on certain trains. During the booking process, you will have the option to select meal preferences in the passenger details section. Simply choose your preferred meal (vegetarian or non-vegetarian) and it will be added to your ticket. For trains with pantry services like Rajdhani, Shatabdi, and Duronto, the meal is often included in the ticket fare.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What happens if the meal I ordered is not delivered?</h3>
                            <p>If the meal you ordered is not delivered during your train journey, you can take the following action:</p>
                            <li><span >Contact Customer Support:</span> Reach out to RailYatri or the food provider’s customer support team through the app or helpline to report the issue.</li>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateProps = createStructuredSelector({
    urlData: selectUrlData
})

export default connect(mapStateProps, null)(FaqDetailsMeal);
